(function($){
  // Event-Handling Print Button (Product Detail, Shopping Cart)
  var $toggle = $('.js-toggle-print'),
      $screenCSS = $('#screenCSS'),
      printURL = $('#printCSS').attr('href');

  $toggle.on('click', function(e) {
    $screenCSS.attr('href', printURL);
  });
})(jQuery);



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/print.js